import { secondaryColor } from "@themes/defaultThemeProps";

import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.js";

const sweetAlertStyle = {
  cardTitle: {
    marginTop: "0",
    marginBottom: "3px",
    color: secondaryColor[2],
    fontSize: "18px"
  },
  center: {
    textAlign: "center"
  },
  right: {
    textAlign: "right"
  },
  left: {
    textAlign: "left"
  },
  alertText: {
    color: secondaryColor[2],
  },
  ...buttonStyle
};

export default sweetAlertStyle;
